import { AbstractControl, ValidatorFn, UntypedFormGroup } from '@angular/forms';
import { IFacility } from '../../../shared/models/IFacility';


export class FacilityValidator {
  static ValidateName(facilities: IFacility[]): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let controlValue = control.value as string;


      let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;

      let existingFacility = facilities.find(x => (x.name.toLowerCase().trim() == controlValue.toLowerCase().trim()) && (x.id.toString() != controlId));

      return existingFacility ? { errorName: true } : null;
    };

  }

  static ValidateODS(facilities: IFacility[]): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let controlValue = control.value as string;

      let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;

      let existingOds = facilities.find(x => (x.originatingDataSource.toLowerCase().trim() == controlValue.toLowerCase().trim())
        && (x.id.toString() != controlId));

      return existingOds ? { errorODS: true } : null;
    };

  }
}